import type { ChartReadEnd, ChartReadStart } from 'interfaces/chartOfSection.interface';

type ReadCategory = 'd' | 'w' | 'm' | 'y';

export const getReadCategory = ( value: ChartReadStart | ChartReadEnd ): ReadCategory | null => {
  if ( value.startsWith( 'd' ) ) {
    return 'd';
  }
  if ( value.startsWith( 'w' ) ) {
    return 'w';
  }
  if ( value.startsWith( 'm' ) ) {
    return 'm';
  }
  if ( value.startsWith( 'y' ) || value.startsWith( 'a' ) ) {
    return 'y';
  }
  return null;
};

export const isReadCategoryMismatch = ( readStart: ChartReadStart, readEnd: ChartReadEnd ): boolean => {
  return getReadCategory( readStart ) !== getReadCategory( readEnd );
};
